import { Device } from '@capacitor/device';
import { isAndroidCapacitor } from './platform';
import i18n from '../i18n';

/**
 * Force sync Android device language with i18n after initialization
 * This is a workaround for async detection timing issues
 */
export const syncAndroidLanguage = async () => {
  if (!isAndroidCapacitor()) {
    return;
  }
  
  // Don't override if user has manually selected a language
  const cachedLang = localStorage.getItem('i18nextLng');
  if (cachedLang) {
    return;
  }
  
  try {
    // Get device language
    let deviceLanguage: string | undefined;
    
    try {
      const langTag = await Device.getLanguageTag();
      if (langTag?.value) {
        deviceLanguage = langTag.value.split('-')[0].toLowerCase();
      }
    } catch (e) {
      const langCode = await Device.getLanguageCode();
      if (langCode?.value) {
        deviceLanguage = langCode.value.toLowerCase();
      }
    }
    
    if (deviceLanguage && deviceLanguage !== i18n.language) {
      await i18n.changeLanguage(deviceLanguage);
    }
  } catch (error) {
    console.error('[syncAndroidLanguage] Error:', error);
  }
};